import { RESET_ORDER } from './types';

export function resetOrder() {
  return {
    type: RESET_ORDER,
  };
}
